import { fetchAuthToken } from '@api/common/api.js'
import { useEffect } from 'react'

const TestPage = () => {
  const baseUrl = import.meta.env.VITE_API_BASE_URL
  // const baseUrl = 'http://localhost:5173'

  const TEST_PARAMS = {
    A: {
      title: '기준시세(전체) + 4개 거래소',
      companyCode: `00000000`,
      bridge: 'N'
    },
    B: {
      title: '4개 거래소만 (KB pay)',
      companyCode: '00000001',
      bridge: 'N'
    },

    C: {
      title: '기준시세만(전체)',
      companyCode: `00000002`,
      bridge: 'N'
    },
    D: {
      title: '업비트/빗썸',
      companyCode: `00000004`,
      bridge: 'N'
    },
    E: {
      title: '미래에셋',
      companyCode: `00000011`,
      bridge: 'N'
    }
  }
  const TEST_TOKENS = {
    F: {
      title: '업비트',
      token:
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOlsi7JeFIl0sInNjb3BlIjpbIk9SR19DTElFTlQiLCJPUkdfU1lTVEVNIl0sImV4cCI6MTg1MjQ1MjA5NSwiYXV0aG9yaXRpZXMiOlsiUk9MRV9PUkdfQ0xJRU5UIiwiUk9MRV9PUkdfU1lTVEVNIl0sImp0aSI6IjU4OTFjOWY1LTJjZDQtNDI0Mi04MjVlLTIxYTkzYzA2YWQ5OSIsImNsaWVudF9pZCI6IjNjMGY5N2U1LTRjMjUtNDYyOC1iZWU1LTM2NWQ1M2MyZmY3MyJ9.21OiJ1ZELFHKrS2SpXXYWX5MpQDUUeEroFxalbF5iuFbtVuyOjZsdgD6b53cxbpXX-Xp73nsvfyrtluHxZdWaQPLErlFZSkrLc2nRxdQvNDUpmfA6guuf8d79A29cSyWH90eNkVRfrlQBzzg6FTU91vZPyMj29ChuVMmtj7lMsPwv0YCFxWfNhSKlVJ2Ef6L7j6HZOd8X_VZNqQSkCu05bn1BAPlZAWqc3rwX5SYK90Kc_WsxPNIoj-aIuBtKALrwl5RPis2jfWWGURa_xVBPFRqXVRuKZSUHPzKK98Zk69g8LMfZZ2PTn4Ua6Hh6Gi1Au6cUubRItuYjn_5wBnFZTBEOzqLjQLbi85jT_N69clijKP5Mw_-DCdmqv1LHx_GzeYUPruvhOdzRaPb_BiIEIoAEYN_H4pyvX_-dB3hxnSMxIJQzh0jL8Sl73-4sQaQWWaJWNV4xIW1Rbj96PkYoiUm0Vs7iD5x1oKspQqodhHIV5vbC5A8s8zAAtkBRgUq',
      bridge: 'N'
    },
    G: {
      title: '빗썸/코빗',
      token:
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOlsi7JeF67mX7L2lIl0sInNjb3BlIjpbIk9SR19DTElFTlQiLCJPUkdfU1lTVEVNIl0sImV4cCI6MTg1MjQ1MjIzMiwiYXV0aG9yaXRpZXMiOlsiUk9MRV9PUkdfQ0xJRU5UIiwiUk9MRV9PUkdfU1lTVEVNIl0sImp0aSI6ImU3YjdmN2JjLTY4ZjItNGNlNC05N2E2LWVkOGY5ZmVlYTYyNyIsImNsaWVudF9pZCI6IjIzNzUzNTkxLWY0OTgtNDgwNi1hOTUxLWY2NGU4ODliZjRjZiJ9.TSOarNGVBKR-PFfKp_5iB30jp9Nzd2bVCkj8xiu4_PEOi0v_G538owrrm3-dROVfn4iT01KY8qIwQVNwX1jhHHc8tyfcsi0tCJIB5FMj-3iQEuDwlLTX3uv46lD-xreQ_8bTagv4gtH-dRZRbRiuaiWnvf6nmlS3szKC9_NWvkvvbMNEvakCt263yX1zuXmE1HRLu-Iukq9ON12qqL2UKqLzE7DEt4aRkMkewQ3sipS7OwvmtUep8NfaSk5OesIXwM8scqP40DeUC5hWvt3bL1_r0SNbI6a2xgv-tnURhN1tEBdMiCvGtoKjbxrgbcZ-dNeO0qUjaILSgnrwVyMpCZk_kM2sr9Xkz-_JQ6fxXyTwJGE_2sRxdsa7_5VKMvD3ET0DKEuxyhh-5zTmsIs56K2RMF0y4P9cPXt4ax_5P0xkfbfgrfdwAotFY8OcDZtU8-s_GkuVORKTML8W1i1ufN01mpqB4vfNTvHyDFufTnMkTQ2a0Y5LeSjzvBWHMQgK',
      bridge: 'N'
    }
  }

  const handleClick = (e, bridge, companyCode) => {
    e.preventDefault()
    window.location.href = `${baseUrl}?bridge=${bridge}&companyCode=${companyCode}`
  }

  // 앱에서 토큰 넘어오는 것 시뮬레이션
  const handleTest = async (e, bridge, token) => {
    e.preventDefault()
    await fetchAuthToken(token)
    window.location.href = `${baseUrl}?bridge=${bridge}`
  }
  useEffect(() => {
    localStorage.removeItem('searchHistory')
  }, [])
  return (
    <div className={'x-spacing y-spacing h-screen bg-white'}>
      <h2 className={'text-24 text-center font-bold'}>시나리오 테스트</h2>
      <div className={'grid-1 mt-32 grid gap-16'}>
        {Object.entries(TEST_PARAMS).map(([key, { title, bridge, companyCode }]) => (
          <button
            key={key}
            onClick={(e) => handleClick(e, bridge, companyCode)}
            className={'border-gray rounded-lg border px-16 py-16'}
          >
            {title}
          </button>
        ))}
        {Object.entries(TEST_TOKENS).map(([key, { title, token, bridge }]) => (
          <button
            key={key}
            onClick={(e) => handleTest(e, bridge, token)}
            className={'border-gray rounded-lg border px-16 py-16'}
          >
            {title}
          </button>
        ))}
      </div>
    </div>
  )
}

export default TestPage
